import { switchAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { colors } from '../cssVariables'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  switchAnatomy.keys,
)

const baseStyle = definePartsStyle({
  track: {
    borderRadius: 0,
    border: `1px solid ${colors.colorB4}`,
    background: '#514F6366',
    _checked: {
      border: `1px solid ${colors.colorA2}`,
      background: '#1CEF4B33',
    },
  },
  thumb: {
    background: colors.colorB3,
    _checked: {
      background: colors.colorA2,
    },
  },
})

export const Switch = defineMultiStyleConfig({
  baseStyle,
})
